import * as React from 'react';
import {STATUS} from "../../types/enums";

interface Props {
    status: number
    appointedStatus: 'appointed' | 'confirmed' | 'refused'
    onVisibleDialogs: (name: string) => () => void
    onAppointmentRequest: (name: string) => () => void
}

const SpecialistActions = ({status, appointedStatus, onVisibleDialogs, onAppointmentRequest}: Props) => {
    const isProcessing = STATUS[status] === 'Processing' //15
    const isAppointed = appointedStatus === 'appointed'

    return (
        <>
            {isProcessing && isAppointed && (
                <>
                    <button
                        className="btn btn-sm pull-right btn-info"
                        onClick={onVisibleDialogs('respondRequest')}
                    >
                        Ответить
                    </button>

                    <button
                        className="btn btn-sm pull-right btn-success"
                        onClick={onAppointmentRequest('appointmentRequest')}
                    >
                        Назначить мне
                    </button>
                    <button
                        className="btn btn-sm pull-right btn-danger"
                        onClick={onVisibleDialogs('rejectRequest')}
                    >
                        Отказаться
                    </button>
                </>
            )}
        </>
    );
};

export default SpecialistActions;

